import React, { useEffect, useRef, useState } from 'react'
import { addDays } from 'date-fns'

import { formatCurrency, formatString } from '../../../utilities/helpers'

import Modal from 'react-bootstrap/Modal'
import CloseButton from 'react-bootstrap/CloseButton'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Stack from 'react-bootstrap/Stack'

import { BackButton } from '../../BackButton'
import { SelectPaymentDueDate } from '../../../providers/AssignToProvider/SelectPaymentDueDate'
import { Spinner } from '../../LoadingContainer/Spinner'

export default function MarkAsComplete({
  paymentType,
  amountToCollect,
  createOrder,
  showAssignmentSuccess,
  onClose,
  onAbandon,
}) {
  const [isMarkCompleteLater, setIsMarkCompleteLater] = useState(false)

  const [dueDateOpt, setDueDateOpt] = useState()

  const [customDueDate, setCustomDueDate] = useState()

  const [isSaving, setIsSaving] = useState(false)

  const submittedRef = useRef(false)

  // Read through a ref so an inline prop does not re-run the effect on every
  // render, which would report abandonment while the dialog is still open.
  const onAbandonRef = useRef(onAbandon)
  onAbandonRef.current = onAbandon

  // The caller holds seats for this sale, so closing without submitting — via the
  // X, the backdrop or Esc — has to hand them back.
  useEffect(() => {
    return () => {
      if (!submittedRef.current) onAbandonRef.current?.()
    }
  }, [])

  const create = (e, dueDate) => {
    setIsSaving(true)
    submittedRef.current = true
    createOrder('', showAssignmentSuccess, dueDate)
  }

  const handleGoBack = () => {
    setIsMarkCompleteLater(false)
  }

  const handleSave = () => {
    let dueDate
    if (dueDateOpt === 'custom') {
      dueDate = customDueDate
    } else {
      // tomorrow, 7, 14 etc.
      if (dueDateOpt > 0) {
        dueDate = addDays(new Date(), dueDateOpt)
      } else {
        // today
        dueDate = new Date()
      }
    }

    create(undefined, dueDate.toISOString())
  }

  return (
    <Modal.Body className="modal--lg">
      <CloseButton className="pos-absolute-close" onClick={onClose} />
      <Stack
        gap={4}
        className="img--round-before img--round-before-lg background-icon-xxl background-icon-tertiary background-icon-info"
      >
        <h4 className="text-center modal-body-heading-title mb-0">
          Mark {formatString(paymentType)} payment as complete
          {isMarkCompleteLater ? ' later' : '?'}
        </h4>
        {!isMarkCompleteLater && (
          <p>
            Ensure you have the right amount ready before finalizing the{' '}
            <span className="fw-semi-bold">{formatString(paymentType)}</span>{' '}
            payment. Marking the payment as complete now will secure the ticket
            assignment for this buyer.
          </p>
        )}
        <Card body className="card--xs info-card card-with-border">
          <Card.Text className="info-text info-text-md">
            <span>
              Amount to collect via {formatString(paymentType)} from buyer:{' '}
              <span className="normal normal-bold">
                {formatCurrency(amountToCollect)}
              </span>
            </span>
          </Card.Text>
        </Card>
        {isMarkCompleteLater && (
          <SelectPaymentDueDate
            dueDateOpt={dueDateOpt}
            setDueDateOpt={setDueDateOpt}
            customDueDate={customDueDate}
            setCustomDueDate={setCustomDueDate}
          />
        )}
      </Stack>
      <Stack
        direction={isMarkCompleteLater ? 'horizontal' : 'vertical'}
        className="btn-group-flex"
      >
        {isMarkCompleteLater ? (
          <>
            <BackButton size="sm" handleGoBack={handleGoBack} />
            <Button
              size="lg"
              className="flex-grow-1"
              onClick={handleSave}
              disabled={!dueDateOpt || !customDueDate || isSaving}
            >
              {isSaving ? <Spinner /> : 'Complete & issue invoice'}
            </Button>
          </>
        ) : (
          <>
            <Button
              size="lg"
              variant="outline-light"
              onClick={() => setIsMarkCompleteLater(true)}
            >
              Mark as complete later
            </Button>
            <Button size="lg" onClick={create} disabled={isSaving}>
              {isSaving ? <Spinner /> : 'Mark as complete now'}
            </Button>
          </>
        )}
      </Stack>
    </Modal.Body>
  )
}
